// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement, Alert, Component, Fragment, Translate, Dialog, Button, PropTypes, Toaster } from '@plesk/ui-library';
import Plesk from '../../plesk';

class NewsletterSubscription extends Component {
    state = {
        isOpen: true,
        state: null,
    };

    getText() {
        const { email } = this.props;
        const { locale } = this.context;

        return locale.lmsg('consent', { email });
    }

    handleSubscribe = () => {
        const { email, reportConsent } = this.props;

        this.setState({
            state: 'submit',
        });

        reportConsent(email, true, this.getText(), success => {
            this.setState({
                state: null,
                isOpen: false,
            });

            if (success) {
                this.toaster.add({
                    intent: 'success',
                    message: <Translate content="subscribeMessage" />,
                });
            } else {
                this.toaster.add({
                    intent: 'danger',
                    message: <Translate content="errorMessage" />,
                });
            }
        });
    };

    handleClose = () => {
        const { email, reportConsent } = this.props;
        const { state } = this.state;

        if (state) {
            return;
        }

        this.setState({
            state: 'cancel',
        });

        reportConsent(email, false, this.getText(), success => {
            this.setState({
                state: null,
                isOpen: false,
            });

            if (success) {
                this.toaster.add({
                    intent: 'success',
                    message: <Translate content="unsubscribeMessage" />,
                });
            } else {
                this.toaster.add({
                    intent: 'danger',
                    message: <Translate content="errorMessage" />,
                });
            }
        });
    };

    render() {
        const { imageSrc, email } = this.props;
        const { isOpen, state } = this.state;

        return (
            <Fragment>
                <Dialog
                    isOpen={isOpen}
                    size="sm"
                    image={<img src={imageSrc} style={{ maxWidth: '326px' }} />}
                    title={<Translate content="title" />}
                    form={{
                        state,
                        onSubmit: this.handleSubscribe,
                        submitButton: { children: <Translate content="subscribeButton" /> },
                        cancelButton: { children: <Translate content="closeButton" /> },
                        hideRequiredLegend: true,
                    }}
                    onClose={this.handleClose}
                >
                    <p>
                        <Translate content="text" />
                    </p>
                    <p>
                        <Alert intent="info">
                            <Translate content="consent" params={{ email }} />
                        </Alert>
                    </p>
                </Dialog>
                <Toaster ref={ref => (this.toaster = ref)} />
            </Fragment>
        );
    }
}

NewsletterSubscription.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    reportConsent: PropTypes.func.isRequired,
};

NewsletterSubscription.contextTypes = {
    locale: PropTypes.object,
};

export default NewsletterSubscription;



// WEBPACK FOOTER //
// ./app/newsletter-subscription/NewsletterSubscription.js